import type { StateCreator } from 'zustand'

export interface DevToolsState {
  showLinkOverlay: boolean
  toggleLinkOverlay: () => void
  showEnvironmentLogo: boolean
  toggleEnvironmentLogo: () => void
  showDemoPatientsOnly: boolean
  toggleDemoPatientsOnly: () => void
  // Read once at page load (installDemoModeIfStored), so a change needs a reload:
  // use setDemoModeAndReload().
  demoMode: boolean
  setDemoMode: (on: boolean) => void
  devToolsActive: boolean
  showAdminActions: boolean
  toggleAdminActions: () => void
  showReactQueryDevtools: boolean
  toggleReactQueryDevtools: () => void
  showMemo: boolean
  toggleMemo: () => void
}

export const createDevToolsStore: StateCreator<DevToolsState> = (set) => ({
  showLinkOverlay: false,
  toggleLinkOverlay: () =>
    set(
      updateDevToolsActive((state) => ({
        showLinkOverlay: !state.showLinkOverlay,
      }))
    ),
  showEnvironmentLogo: true,
  toggleEnvironmentLogo: () =>
    set(
      updateDevToolsActive((state) => ({
        showEnvironmentLogo: !state.showEnvironmentLogo,
      }))
    ),
  showDemoPatientsOnly: false,
  toggleDemoPatientsOnly: () =>
    set(
      updateDevToolsActive((state) => ({
        showDemoPatientsOnly: !state.showDemoPatientsOnly,
      }))
    ),
  demoMode: false,
  setDemoMode: (on) => set(updateDevToolsActive(() => ({ demoMode: on }))),
  showAdminActions: false,
  toggleAdminActions: () =>
    set(
      updateDevToolsActive((state) => ({
        showAdminActions: !state.showAdminActions,
      }))
    ),
  showReactQueryDevtools: false,
  toggleReactQueryDevtools: () =>
    set(
      updateDevToolsActive((state) => ({
        showReactQueryDevtools: !state.showReactQueryDevtools,
      }))
    ),
  showMemo: false,
  toggleMemo: () =>
    set(
      updateDevToolsActive((state) => ({
        showMemo: !state.showMemo,
      }))
    ),
  devToolsActive: true,
})

function updateDevToolsActive(
  set: (state: DevToolsState) => Partial<DevToolsState>
): (state: DevToolsState) => Partial<DevToolsState> {
  return (state) => {
    const newState = set(state)
    return {
      ...newState,
      devToolsActive:
        (newState.showLinkOverlay ?? state.showLinkOverlay) ||
        (newState.showEnvironmentLogo ?? state.showEnvironmentLogo) ||
        (newState.showDemoPatientsOnly ?? state.showDemoPatientsOnly) ||
        (newState.demoMode ?? state.demoMode) ||
        (newState.showAdminActions ?? state.showAdminActions) ||
        (newState.showReactQueryDevtools ?? state.showReactQueryDevtools) ||
        (newState.showMemo ?? state.showMemo),
    }
  }
}
